common.View.create('admin::layouts.main.sidebar.Structure', {

    onDOMLoad() {
        let toggleSidebarButton = this.element.find('#toggleSidebarButton');
        let sidebarPreference = localStorage.getItem('sidebarPreference');

        this.manageAriaExpanded(toggleSidebarButton, sidebarPreference);
        this.fixClassesOnResize(toggleSidebarButton, sidebarPreference);
    },

    manageAriaExpanded(toggleSidebarButton, sidebarPreference) {
        if ($(window).width() <= 1280 || sidebarPreference === 'false') {
            this.manageCloseSidebar(toggleSidebarButton);
        }

        this.initToggleSidebar(toggleSidebarButton);
    },

    initToggleSidebar(toggleSidebarButton) {
        toggleSidebarButton.on('click', () => {
            if (toggleSidebarButton.attr('aria-expanded') === 'true') {
                this.manageCloseSidebar(toggleSidebarButton);
            } else {
                this.manageExpandSidebar(toggleSidebarButton);
            }

            this.rememberSidebarPreference(toggleSidebarButton);
        });
    },

    rememberSidebarPreference(toggleSidebarButton) {
        localStorage.setItem('sidebarPreference', toggleSidebarButton.attr('aria-expanded'));

        $.ajax({
            url: toggleSidebarButton.data('preference') + '?preference=' + toggleSidebarButton.attr('aria-expanded'),
        });
    },

    manageExpandSidebar(toggleSidebarButton) {
        $('.galaxySidebar').removeClass('w-20').addClass('w-60');
        if ($(window).width() > 1280) {
            $('.baseOnSidebarPref').removeClass('ml-20').addClass('ml-60');
        }

        this.manageSidebarMargins(false);
        this.manageToggleTextState(toggleSidebarButton, false);

        toggleSidebarButton.attr('aria-expanded', 'true');
    },

    manageCloseSidebar(toggleSidebarButton) {
        $('.galaxySidebar').removeClass('w-60 xl:w-60').addClass('w-20');
        $('.baseOnSidebarPref').removeClass('ml-60 xl:ml-60').addClass('ml-20');

        this.manageSidebarMargins();
        this.manageToggleTextState(toggleSidebarButton);

        toggleSidebarButton.attr('aria-expanded', 'false');
    },

    manageToggleTextState(toggleSidebarButton, expanded = true) {
        if (expanded) {
            toggleSidebarButton.find('i').removeClass('inline-block xl:hidden hidden');
            toggleSidebarButton.find('span').addClass('hidden');
        } else {
            setTimeout(() => {
                toggleSidebarButton.find('i').addClass('hidden');
                toggleSidebarButton.find('span').removeClass('xl:inline-block hidden');
            }, 50);
        }
    },

    manageSidebarMargins(expanded = true) {
        if (expanded) {
            this.element.find('.galaxyLogoWrapper').removeClass('px-8 xl:px-8').addClass('px-4 small').end()
                .find('nav.menu > ul > li > a div').removeClass('ml-3 xl:ml-3').addClass('ml-0')
                .find('i').removeClass('mr-2 xl:mr-2').addClass('mr-0').end().end()
                .find('span').removeClass('xl:inline-block ml-5 xl:ml-5').addClass('hidden');

            this.element.find('nav.menu > ul > li.active > ul > li > .item').addClass('justify-center').removeClass('ml-5 xl:ml-5')
                .find('i').removeClass('hidden mr-2').end()
                .find('div').removeClass('hidden xl:hidden ml-3');

            this.element.find('nav.menu > ul > li.active > ul > li > .alternate-item').addClass('justify-center').removeClass('xl:justify-start ml-5 xl:ml-5 my-3')
                .find('i').removeClass('hidden mr-2 xl:mr-2').end()
                .find('div').removeClass('hidden xl:hidden xl:ml-3 ml-3');
        } else {
            this.element.find('.galaxyLogoWrapper').removeClass('px-4 small').addClass('px-8').end()
                .find('nav.menu > ul > li > a span').removeClass('hidden');

            this.element.find('nav.menu > ul > li.active > ul > li > .item').removeClass('justify-center').addClass('ml-5')
                .find('i').addClass('hidden mr-2').end()
                .find('div').addClass('hidden ml-3');

            this.element.find('nav.menu > ul > li.active > ul > li > .alternate-item').removeClass('justify-center xl:justify-start').addClass('my-3')
                .find('i').addClass('hidden mr-2').end()
                .find('div').addClass('hidden ml-3').end()
                .find('span').removeClass('hidden').addClass('xl:inline-block ml-5 xl:ml-5');

            setTimeout(() => {
                this.element.find('nav.menu > ul > li > a div').addClass('ml-3')
                    .find('i').addClass('mr-2');
            }, 50);
        }
    },

    fixClassesOnResize(toggleSidebarButton, sidebarPreference) {
        $(window).resize(() => {
            if ($(window).width() <= 1280) this.manageCloseSidebar(toggleSidebarButton);
            if ($(window).width() >= 1280 && sidebarPreference === 'true') this.manageExpandSidebar(toggleSidebarButton);
        });
    }
});
